import { Box, Typography } from '@mui/material';
import React from 'react'
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BASE_COLORS } from '../../utils/colors';

function ReusableAreaChart({title , data, width}) {
  return (
    <Box
      sx={{
        background: "white",
        width: {
          xs: "100%",
          sm: width,
        },
        padding: {
          xs: "16px",
          sm: "24px",
        },
        display: "flex",
        textAlign: "left",
        gap: "8px",
        borderRadius: "16px",
        flexDirection: "column",
        height: "auto",
        minHeight: "320px"
      }}
    >
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      <ResponsiveContainer
        width="100%"
        height="100%"
        style={{ margin: "auto", textAlign: "center" }}
      >
        <AreaChart
          data={[...(data || [])].reverse()}
          margin={{ top: 20, right: 0, left: 30, bottom: 0 }}
        >
          <XAxis dataKey="date" padding={{ left: 30, right: 0 }} />
          <YAxis orientation="right" />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="amount"
            stroke={BASE_COLORS[0]}
            fill={BASE_COLORS[1]}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default ReusableAreaChart